import React, { useEffect, useState } from 'react';
import Box from '../../../../atomic/Box';
import Grid from '../../../../atomic/Grid';
import Checkbox from '../../../../atomic/Checkbox';
import Typography from '../../../../atomic/Typography';
import useDesktop from '../../../../../hooks/useDesktop';
import Divider from '../../../../atomic/Divider';
import { useFindProfessionalsStyles } from '../../../findProfessionalStyles';

const CertificateFilter = ({
  selectedOptions,
  certificates,
  reset = false,
  showHeading = true,
  onSelect = () => {},
}) => {
  const isDesktop = useDesktop();
  const classes = useFindProfessionalsStyles();
  const [options, setOptions] = useState(
    selectedOptions !== '' ? selectedOptions.split(',') : []
  );

  const handleOptionChange = (o) => {
    const index = options.indexOf(o);
    if (index === -1) {
      setOptions([...options, o]);
    } else {
      setOptions(options.filter((s) => s !== o));
    }
  };

  useEffect(() => {
    onSelect(options);
  }, [options.length]);

  useEffect(() => {
    if (reset) {
      setOptions([]);
    }
  }, [reset]);

  return (
    <Box sx={{ flexGrow: 1 }} p={!isDesktop && 2}>
      {showHeading && (
        <Typography
          className={
            isDesktop
              ? classes.moreFiltersSubTitles
              : classes.moreFiltersSubTitlesMobile
          }
        >
          Sertifiseringer
        </Typography>
      )}
      <Grid container spacing={0} columns={{ xs: 1, sm: 8 }}>
        {certificates.map((cert) =>
          isDesktop ? (
            <Grid item xs={6} sm={6} md={6} key={`certificate-${cert.name}`}>
              <Box pl={2} pr={2}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    cursor: 'pointer',
                  }}
                  onClick={() => handleOptionChange(cert.name)}
                >
                  <Typography className={classes.moreFilterContent}>
                    {cert.displayName}
                  </Typography>
                  <Checkbox
                    value={cert.name}
                    checked={options.includes(cert.name)}
                    onChange={(e) => handleOptionChange(e.target.value)}
                    classes={{ label: classes.moreFilterContent }}
                  />
                </Box>
                <Divider />
              </Box>
            </Grid>
          ) : (
            <Grid item xs={12} sm={12} md={12} key={`certificate-${cert.name}`}>
              <Checkbox
                label={cert.displayName}
                value={cert.name}
                checked={options.includes(cert.name)}
                onChange={(e) => handleOptionChange(e.target.value)}
                classes={{ label: classes.moreFilterContent }}
              />
            </Grid>
          )
        )}
      </Grid>
    </Box>
  );
};

export default CertificateFilter;
